/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames as cx } from '@ba-ui-toolkit/utils';

// TODO do we want to bring in style ?
// import './styles/index.scss';

import HighContrastDetect from './HighContrastDetect';
import './Root.scss';

export default class Root extends Component {
	static propTypes = {
		className: PropTypes.string,
	};

	render() {
		const { className, ...props } = this.props;

		return (
			<HighContrastDetect>
				<div {...props} className={cx('ba-common-root', className)} />
			</HighContrastDetect>
		);
	}
}
